<template>
  <div v-if="!isMobile" class="owner-viewer-app-controls" data-testid="owner-viewer-app-controls">
    <span class="owner-viewer-app-controls__divider" aria-hidden="true" />
    <Notifications />
    <UserMenu :is-expanded="false" :name="name || email" :avatar="avatarUrl" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import Notifications from '@/components/layout/header/notifications/Notifications.vue';
import UserMenu from '@/components/sidebar/menu/User.vue';
import { useMobileDetection } from '@/composables/useMobileDetection';
import { useUserStore } from '@/store/useUserStore';

const { isMobile } = useMobileDetection();
const { avatarUrl, name, email } = storeToRefs(useUserStore());
</script>

<style scoped>
.owner-viewer-app-controls {
  @apply flex items-center gap-2 flex-none;
}

.owner-viewer-app-controls__divider {
  @apply h-7 w-px mx-3 bg-slate-200 dark:bg-zinc-700;
}

.owner-viewer-app-controls :deep([data-testid='header-notifications']) {
  @apply shrink-0;
}

.owner-viewer-app-controls :deep(.sidebar-user-menu) {
  @apply shrink-0 max-w-none;
}
</style>
